import { createSelector } from 'reselect'

import selectTrelloCardsById from './selectTrelloCardsById'

export default createSelector(selectTrelloCardsById, cards => {
  if (!cards) return cards
  return Object.values(cards)
})
